import { BiddingSpotBidStatus } from '@ebalance/proto/bffuser/v1/bidding_common_model_pb'

/**
 * 札・ブロック入札グループの取下の進み具合。 ステータス列とは別に一覧へ併記する
 * (AC-BSP-057b: 取下の再試行中もステータスは「入札中」 のまま)。
 */
export type BidWithdrawState = 'withdrawing' | 'withdrawFailed'

/** 通常入札の札の取下の進み具合。 取下が進んでいない札は undefined。 */
export const resolveSpotBidWithdrawState = (
  bidStatus: BiddingSpotBidStatus,
): BidWithdrawState | undefined => {
  switch (bidStatus) {
    case BiddingSpotBidStatus.WITHDRAWING:
      return 'withdrawing'
    case BiddingSpotBidStatus.WITHDRAW_FAILED:
      return 'withdrawFailed'
    default:
      return undefined
  }
}

/**
 * 一覧に出す取下の進み具合。 取下失敗の札に要確認の印が付いている間は、 取下失敗の表示と添える文を
 * 出さず要確認の印だけにする (AC-BSP-125。 印が消えれば取下失敗に戻る)。 通常入札の表とブロック
 * 入札の表が同じ規則で使う。
 */
export const listedWithdrawState = (
  state: BidWithdrawState | undefined,
  needsReview: boolean | undefined,
): BidWithdrawState | undefined =>
  state === 'withdrawFailed' && needsReview === true ? undefined : state

/**
 * 取下の進み具合に添える説明の i18n key。 締切後は制度上取り消せないので、 取下失敗には
 * 取消の手順を案内しない説明を出す (AC-BSP-057b / AC-BSP-058)。
 */
export const withdrawStateHintKey = (
  state: BidWithdrawState,
  isPastDeadline: boolean,
): string => {
  if (state === 'withdrawing')
    return 'page:biddingSpot.withdrawState.pendingHint'
  return isPastDeadline
    ? 'page:biddingSpot.withdrawState.failedAfterDeadlineHint'
    : 'page:biddingSpot.withdrawState.failedHint'
}
